import angular, { ILogService } from 'angular'
import { chain, max, maxBy } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { MainQuestionEdit } from 'src/_candidato/data/main-question'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IModelMainQuestion } from 'src/model/candidato-api'

class PanelMainQuestionsComponentCtrl {
  list: MainQuestionEdit[]

  constructor(private $log: ILogService, private NotifService: NotificacionService, private AccesoDatos: AccesoDatos) {}

  $onInit(): void {
    this.$log.info('[PanelMainQuestionsComponentCtrl] onInit')

    this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipalesConPreg().then((responseList) => {
      this.list = chain(responseList)
        .map((mq) => new MainQuestionEdit(mq))
        .value()
    })
  }

  nuevaMainQ() {
    const maxmq = maxBy(this.list, (mq1) => mq1.data.mq.orden)

    const mq = new MainQuestionEdit({
      mq: {
        noactivo: false,
        usar_busquedas: true,
        usar_listado: true,
        orden: !!maxmq ? (maxmq.data.mq.orden || 0) + 1 : 1,
      } as IModelMainQuestion,
    })
    mq.nuevoreg = true
    this.list.push(mq)
  }
}

angular.module('candidato').component('panelMainQuestions', {
  bindings: {},
  controller: PanelMainQuestionsComponentCtrl,
  // templateUrl: "panel-main-questions.component.html",
  template: require('./panel-main-questions.component.html'),
})
